"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Switch_1 = __importDefault(require("@material-ui/core/Switch"));
var Switch = function (_a) {
    var classes = _a.classes, checked = _a.checked, checkedIcon = _a.checkedIcon, _b = _a.color, color = _b === void 0 ? 'primary' : _b, disabled = _a.disabled, disableRipple = _a.disableRipple, edge = _a.edge, icon = _a.icon, id = _a.id, inputProps = _a.inputProps, inputRef = _a.inputRef, onChange = _a.onChange, required = _a.required, _c = _a.size, size = _c === void 0 ? 'medium' : _c, value = _a.value;
    return (react_1.default.createElement(Switch_1.default, __assign({ classes: classes, checked: checked, color: color, disabled: disabled, disableRipple: disableRipple, edge: edge }, icon ? { icon: icon } : {}, checkedIcon ? { checkedIcon: checkedIcon } : {}, { id: id, inputProps: inputProps, inputRef: inputRef, onChange: onChange, required: required, size: size, value: value })));
};
exports.default = Switch;
